module.exports = __webpack_public_path__ + "static/media/bg-pattern-mobile.40d8475d.svg";